// extracted by mini-css-extract-plugin
module.exports = {"linkedAccountBalanceNote":"LinkedAccountBalanceNote__linkedAccountBalanceNote__bj-vX"};